/**
 * A code filter's picker ids: the codes in scope, then any selected code the
 * scope no longer holds (a division or location change keeps the URL pick).
 * Keeping those visible stops the picker and summary hiding a filter that
 * still narrows the board.
 */
export function withSelectedCodes(
  codes: readonly string[],
  selected: readonly string[],
): string[] {
  const inScope = new Set(codes);
  return [...codes, ...selected.filter((code) => !inScope.has(code))];
}
